import styled from 'styled-components';

export const ContainerLoja = styled.div`
  width: 100%;
  padding: 0 1.5rem;
  max-width: 700px;
`;

export const ContentLoja = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  width: 100%;
`;

export const SettingsCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 1rem;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
  }
  svg {
    color: #3b82f6;
    font-size: 1.2rem;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`;
